import DocPage from '../components/DocPage.jsx'
import { docsHoops } from '../content.js'

// /docs/hoops — P6-104. Half of the old "NBA and fantasy" section. The other
// half was DocsFantasy.jsx, which P6-165 removed when P6-166 shelved
// `cogs.fantasy`: a page describing a feature nobody can use comes down until
// the feature is back. The split is at a sentence boundary and nothing was
// rewritten — see the $comment in content-src/docs-hoops.json.

export default function DocsHoops() {
  return <DocPage doc={docsHoops} />
}
